export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20entertainment%20brand%20hero%20background%20with%20dark%20ambient%20atmosphere%2C%20golden%20geometric%20patterns%20and%20subtle%20gradient%20lighting%2C%20premium%20gaming%20theme%2C%20sophisticated%20and%20modern%20aesthetic%2C%20deep%20charcoal%20with%20warm%20gold%20accents%2C%20cinematic%20composition%2C%20no%20text%20or%20logos%2C%20clean%20abstract%20background&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="必赢亚洲品牌背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p
            className="text-primary-400 text-sm md:text-base font-medium tracking-widest uppercase mb-3 md:mb-4"
            style={{ fontFamily: "var(--font-label)" }}
          >
            必赢亚洲 · 官方正版平台
          </p>
          <h1
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            安全畅玩
            <span className="text-primary-400">赢无止境</span>
          </h1>
          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed mb-6 md:mb-8">
            必赢亚洲是亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。官方正版授权，安全存取款，极速到账，24小时客服全程护航。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/category/promotions"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              立即注册
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="/about"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm md:text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
            >
              了解更多
              <i className="ri-information-line"></i>
            </a>
          </div>

          <div className="mt-8 md:mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-lg mx-auto">
            {[
              { value: '500万+', label: '注册用户' },
              { value: '1000+', label: '精选游戏' },
              { value: '7×24h', label: '客服在线' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-xl md:text-3xl font-bold text-white" style={{ fontFamily: "var(--font-heading)" }}>
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}